/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { DetailTask } from "../../types";

type UseDetailTask = {
  task_id: string;
  onSuccess?: (data: DetailTask) => void;
};

type Response = {
  payload: DetailTask
};

export function useDetailTask({
  task_id,
  onSuccess
}: UseDetailTask) {
  const api = useApi();
  const [data, setData] = useState<DetailTask | null>(null);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api
      .get(`/task/${task_id}`)
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload
        onSuccess?.(data);
        setData(data);
      })
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    if (task_id) {
      fetchData();
    }

    return () => {
      setData(null);
      setLoading(false);
    };
  }, [task_id]);

  return { data, isLoading, refetch };
}
